import { Button } from '@carbon/react';
import React, { useEffect } from 'react';

import "./_side-forms.scss";

const addBodyClass = (className) => document.body.classList.add(className);
const removeBodyClass = (className) =>
  document.body.classList.remove(className);

function useBodyClass(className) {
  useEffect(() => {
    className instanceof Array
      ? className.map(addBodyClass)
      : addBodyClass(className);

    return () => {
      className instanceof Array
        ? className.map(removeBodyClass)
        : removeBodyClass(className);
    };
  }, [className]);
}

export const SideForm = ({
  children,
  size = 'tall',
  title = 'Überschrift',
  subTitle = 'Sub-Überschrift',
  primaryButton = 'OK',
  secondaryButton = 'Abbruch',
  primaryButtonDisabled = false,
  ref = null,
  onClose = () => {},
  onSubmit = () => {},
}) => {
  useBodyClass('cds--body--with-modal-open');

  return (
    <div role="presentation">
      <div
        className={`cds--modal cds--modal-${size} is-visible`}
        role="presentation"
        tabIndex="-1"
      >
        <div
          role="dialog"
          className="cds--modal-container right-side"
          aria-label="Modal"
          ref={ref}
          aria-modal="true">
          <div className="cds--modal-header">
            <p className="cds--modal-header__label cds--type-delta">{subTitle}</p>
            <p className="cds--modal-header__heading cds--type-beta">{title}</p>
            <div className="modal--header_divider"></div>
          </div>
          <div className="cds--modal-content">
            {children}
            <div style={{ height: '2rem' }}></div>
          </div>
          <div className="cds--modal-footer">
            <Button
              kind="primary"
              size="sm"
              data-modal-primary-focus
              disabled={primaryButtonDisabled}
              onClick={onSubmit}>
              {primaryButton}
            </Button>
            <Button kind="secondary" size="sm" onClick={onClose}>
              {secondaryButton}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
